import { useEffect, useState } from 'react';
import { getProductByProductId } from '../product/productPageApi';
import { ProductViewModel } from '../../types/generated';
import OfferModal from './offerModal';
import { Button } from '../../components/Button';

export default function Offer({
  offer,
  className,
  offerFreeProduct
}: OfferProps) {
  const [showModal, updateShowModal] = useState(false);
  const [freeProduct, setFreeProduct] =
    useState<ProductViewModel | null>(offerFreeProduct);

  useEffect(() => {
    if (freeProduct === null && offer && offer.offerFreeProductId) {
      getProductByProductId(offer.offerFreeProductId).then(
        (data: ProductViewModel) => {
          setFreeProduct(data);
        }
      );
    }
  }, [offer, freeProduct]);

  return (
    <div className="pt-2 pb-2">
      {offer.offerTypeId && offer.offerTypeId !== 0 ? (
        <>
          <Button
            className={className}
            handleClick={() => {
              updateShowModal(true);
            }}
          >
            {offer.offerName}
          </Button>

          <OfferModal
            offer={offer}
            showModal={showModal}
            updateShowModal={updateShowModal}
            freeProduct={freeProduct}
          />
        </>
      ) : (
        <div className="d-none d-md-block pt-4 pb-2 opacity-0"></div>
      )}
    </div>
  );
}

export interface OfferDetails {
  productCatalogueRef: string | null;
  offerTypeId: number;
  offerTypeName: string | null;
  offerName: string | null;
  offerDescription: string | null;
  offerQuantityBuy: number;
  offerQuantityFree: number;
  offerFreeProductId: number;
}

export interface OfferProps {
  offer: OfferDetails;
  className: string;
  offerFreeProduct: ProductViewModel | null;
}
